import { MessageCircle } from 'lucide-react';

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/50687765128"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
      aria-label="Escríbenos por WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20" />
      <span className="absolute inset-0 rounded-full bg-green-500/30 animate-pulse-slow" />
      <MessageCircle className="w-7 h-7 fill-white relative z-10 group-hover:scale-110 transition-transform" />
    </a>
  );
}
